import { toast } from 'sonner';
import { useReducedMotion } from './useReducedMotion';

interface ToastOptions {
  duration?: number;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function useToast() {
  const prefersReducedMotion = useReducedMotion();

  const defaultDuration = prefersReducedMotion ? 5000 : 4000;

  return {
    success: (message: string, opts?: ToastOptions) =>
      toast.success(message, {
        duration: opts?.duration || defaultDuration,
        description: opts?.description,
        action: opts?.action,
      }),

    error: (message: string, opts?: ToastOptions) =>
      toast.error(message, {
        duration: opts?.duration || defaultDuration,
        description: opts?.description,
        action: opts?.action,
      }),

    info: (message: string, opts?: ToastOptions) =>
      toast.info(message, {
        duration: opts?.duration || defaultDuration,
        description: opts?.description,
        action: opts?.action,
      }),

    warning: (message: string, opts?: ToastOptions) =>
      toast.warning(message, {
        duration: opts?.duration || defaultDuration,
        description: opts?.description,
        action: opts?.action,
      }),

    loading: (message: string) => toast.loading(message),

    dismiss: (id?: string | number) => toast.dismiss(id),

    promise: <T,>(
      promise: Promise<T>,
      messages: {
        loading: string;
        success: string | ((data: T) => string);
        error: string | ((error: unknown) => string);
      }
    ) => toast.promise(promise, messages),
  };
}
